import { useEffect, useState } from 'react';
import { IAboutUs } from '../../models/about-us';
import { toast } from 'react-toastify';
import { getAboutUsData } from '../../services/about-us/about-us-service';
import { env } from 'config/env';

export const useAboutUsHook = () => {
  const [aboutUsArray, setAboutUsArray] = useState<Array<IAboutUs>>([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      document.getElementById('loading')?.classList.add('manual-loading');
      const aboutUsData = await getAboutUsData();
      setAboutUsArray(aboutUsData.Data.aboutus || []);
    } catch (error) {
      toast.error(error.response?.message || error.toString());
    } finally {
      document.getElementById('loading')?.classList.remove('manual-loading');
    }
  };

  const handleClick = () => {
    window.location.href = `${env.VITE_REDIRECT_URL}/open-source`;
  };
  return {
    handleClick,
    aboutUsArray,
    fetchData,
  };
};
